import { call, put } from 'redux-saga/effects';
import {
    setControlIngresos,
    savedControlIngreso,
} from '../../ducks/controlIngresos';
import {
    requestLoadControlIngresos,
    requestSaveControlIngreso,
} from '../requests/controlIngresos';

export function* handleLoadControlIngresos() {
    try {
        const response = yield call(requestLoadControlIngresos);
        yield put(setControlIngresos(response.data));
    } catch (error) {
        console.log(error);
    }
}

export function* handleSaveControlIngreso(action) {
    try {
        const response = yield call(requestSaveControlIngreso, action.ingreso);
        yield put(savedControlIngreso(response.data));
    } catch (error) {
        console.log(error);
    }
}
